import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, createBlock as _createBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = ["placeholder"]
const _hoisted_2 = { class: "actions" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "item-text" }
const _hoisted_5 = {
  key: 1,
  class: "item-points"
}

import { ChevronDown, Check, X } from "utruckin-icons";
import { IDropdown, IDropdownOptions } from "@/types/main";
import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomSearchDropdown',
  props: {
    position: { default: "bottom" },
    label: { default: "" },
    items: { default: () => [] },
    modelValue: { default: "" },
    disabled: { type: Boolean, default: false },
    showBadge: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    maxWidth: {},
    dropdownFullWidth: { type: Boolean, default: false },
    isAppendItem: { type: Boolean },
    creatable: { type: Boolean },
    fullWidth: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "search", "enter"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const isOpen = ref(false);
const rootRef = ref<HTMLElement | null>(null);
const inputRef = ref<HTMLInputElement | null>(null);
const search = ref("");
const highlightedIndex = ref(-1);
const itemRefs = ref<HTMLElement[]>([]);

const listStyle = ref({
  top: "0px",
  left: "0px",
  width: "300px",
  transformOrigin: "top",
});

const selectedItem = computed(() => {
  return props.items.find((i) => i.value === props.modelValue) ?? null;
});

const selectedLabel = computed(() => {
  if (selectedItem.value) {
    return selectedItem.value.name;
  }

  return typeof props.modelValue === "string" ? props.modelValue : "";
});
const selectedColor = computed(() => selectedItem.value?.color || null);

const hasSelection = computed(() => selectedLabel.value.length > 0);

// const filteredItems = computed(() => {
//   if (!search.value) return props.items;
//
//   return props.items.filter((item) =>
//     item.name.toLowerCase().includes(search.value.toLowerCase())
//   );
// });

function updateListPosition() {
  if (!rootRef.value) return;
  const rect = rootRef.value.getBoundingClientRect();
  listStyle.value = {
    width: `${rect.width}px`,
    left: `${rect.left + window.scrollX}px`,
    top:
      props.position === "top"
        ? `${rect.top + window.scrollY - 6}px`
        : `${rect.bottom + window.scrollY + 6}px`,
    transformOrigin: props.position === "top" ? "bottom" : "top",
  };
}

const toggle = async (e?: any) => {
  if (e) e.stopPropagation();
  if (props.disabled) return;
  if (!isOpen.value) {
    search.value = selectedLabel.value || "";

    updateListPosition();
    isOpen.value = true;

    highlightedIndex.value = props.items.findIndex(
      (item) => item.value === props.modelValue
    );

    await nextTick();
    inputRef.value?.focus();

    return;
  }
  isOpen.value = false;
};

function onKeydown(e: KeyboardEvent) {
  switch (e.key) {
    case "ArrowDown":
      e.preventDefault();

      highlightedIndex.value = Math.min(
        highlightedIndex.value + 1,
        props.items.length - 1
      );

      scrollHighlightedIntoView();

      break;

    case "ArrowUp":
      e.preventDefault();

      highlightedIndex.value = Math.max(highlightedIndex.value - 1, 0);

      scrollHighlightedIntoView();

      break;

    case "Enter":
      e.preventDefault();

      if (highlightedIndex.value >= 0 && props.items[highlightedIndex.value]) {
        choose(props.items[highlightedIndex.value]);
        emit("enter");
        return;
      }

      break;
  }
}

function scrollHighlightedIntoView() {
  const el = itemRefs.value[highlightedIndex.value];

  if (el) {
    el.scrollIntoView({
      block: "nearest",
    });
  }
}

function choose(item: IDropdown) {
  emit("update:modelValue", item.value);
  isOpen.value = false;
}

function onDocumentClick(e: MouseEvent) {
  const el = rootRef.value;
  if (!el) return;
  const target = e.target as Node | null;
  if (!target) return;
  if (!el.contains(target)) {
    isOpen.value = false;
  }
}

const clearValue = () => {
  emit("update:modelValue", "");
};

onMounted(() => {
  search.value = "";
  document.addEventListener("click", onDocumentClick);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", onDocumentClick);
});

watch(search, (val) => {
  emit("search", val);
});

__expose({
  focus: async () => {
    if (props.disabled) return;

    await nextTick();

    if (!isOpen.value) {
      await toggle();
    }

    await nextTick();

    inputRef.value?.focus?.();
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "rootRef",
    ref: rootRef,
    class: _normalizeClass(["c-cu-table-dropdown", {
      active: isOpen.value,
      disabled: __props.disabled,
      'full-width': __props.fullWidth,
    }]),
    style: _normalizeStyle({ maxWidth: __props.maxWidth }),
    onClick: toggle
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["value", { 'is-placeholder': !hasSelection.value }])
    }, [
      (isOpen.value)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            ref_key: "inputRef",
            ref: inputRef,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
            class: "dropdown-input",
            type: "text",
            placeholder: __props.label,
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
            onKeydown: onKeydown
          }, null, 40, _hoisted_1)), [
            [_vModelText, search.value]
          ])
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (hasSelection.value && selectedColor.value)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "color-dot",
                  style: _normalizeStyle({ backgroundColor: `var(${selectedColor.value})` })
                }, null, 4))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(selectedLabel.value || __props.label), 1)
          ], 64))
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      (__props.clearable && __props.modelValue)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "clear",
            onClick: clearValue
          }, [
            _createVNode(_unref(X), { size: 20 })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["icon", { rotate: isOpen.value }])
      }, [
        _createVNode(_unref(ChevronDown), { size: 20 })
      ], 2)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (isOpen.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "c-cu-table-dropdown__list",
            style: _normalizeStyle({
          position: 'fixed',
          top: listStyle.value.top,
          left: listStyle.value.left,
          width: __props.dropdownFullWidth ? listStyle.value.width : 'auto',
          minWidth: listStyle.value.width,
          transform: __props.position === 'top' ? 'translateY(-100%)' : 'none',
        })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.value || index,
                ref_for: true,
                ref: (el) => { if (el) itemRefs.value[index] = el as HTMLElement },
                class: _normalizeClass(["c-cu-table-dropdown__item", { active: index === highlightedIndex.value }]),
                onClick: _withModifiers(($event: any) => (choose(item)), ["stop"])
              }, [
                (item.color)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "color-dot",
                      style: _normalizeStyle({ backgroundColor: `var(${item.color})` })
                    }, null, 4))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_4, _toDisplayString(item.name), 1),
                (item.app)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.app), 1))
                  : _createCommentVNode("", true),
                (item.value === __props.modelValue)
                  ? (_openBlock(), _createBlock(_unref(Check), {
                      key: 2,
                      class: "check"
                    }))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_3))
            }), 128))
          ], 4))
        : _createCommentVNode("", true)
    ]))
  ], 6))
}
}

})